import React from 'react';
import { resolveDimensionLabel } from '../constants/dimensionLabels';

const GROUP_LABEL = {
  buy: '买入观察',
  hold: '持有支持',
  reduce: '减仓关注'
};

function RuleList({ title, rules }) {
  if (!rules?.length) return null;
  return (
    <div className="checklist-group">
      <div className="checklist-group-title">{title}</div>
      <ul className="checklist-rule-list">
        {rules.map((rule, idx) => (
          <li
            className={`checklist-rule ${rule.triggered ? 'triggered' : ''} severity-${rule.severity}`}
            key={`${rule.dimension}-${idx}`}
          >
            <span className="checklist-rule-mark">{rule.triggered ? '✓' : '○'}</span>
            <span className="checklist-rule-dim" title={rule.dimension}>
              {rule.dimension_label || resolveDimensionLabel(rule.dimension)}
            </span>
            <span className="checklist-rule-text">{rule.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function DecisionChecklistPanel({ checklist }) {
  if (!checklist) return null;

  const { checklist: groups } = checklist;

  return (
    <div className="decision-checklist-panel">
      <div className="checklist-header">
        <span className={`checklist-stance tone-${checklist.stance_tone || 'neutral'}`}>
          {checklist.stance_label}
        </span>
        <span className="decision-muted">
          买入 {checklist.counts?.buy ?? 0} · 减仓 {checklist.counts?.reduce ?? 0}
        </span>
      </div>

      <p className="checklist-summary">{checklist.summary}</p>

      <div className="checklist-groups">
        <RuleList title={GROUP_LABEL.buy} rules={groups?.buy} />
        <RuleList title={GROUP_LABEL.hold} rules={groups?.hold} />
        <RuleList title={GROUP_LABEL.reduce} rules={groups?.reduce} />
      </div>

      {checklist.disclaimer ? (
        <p className="decision-muted checklist-disclaimer">{checklist.disclaimer}</p>
      ) : null}
    </div>
  );
}
